/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  CalendarIcon,
  ChevronDownIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import { components } from "react-select";

export const CustomDropdownWithCalendar = (props: any): JSX.Element => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <CalendarIcon
          className="h-5 text-gray-700 stroke-2"
          aria-hidden="true"
        />
      </components.DropdownIndicator>
    )
  );
};

export const CustomDropdownWithChevron = (props: any): JSX.Element => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <ChevronDownIcon
          className="h-5 text-gray-700 stroke-2"
          aria-hidden="true"
        />
      </components.DropdownIndicator>
    )
  );
};

export const CustomOptionWithCheckbox = (props: any): JSX.Element => {
  return (
    <div data-testid="checkbox-option-container">
      <components.Option {...props}>
        <div className="flex items-center">
          <input
            type="checkbox"
            checked={props.isSelected}
            name="custom-checkbox"
            id="custom-checkbox"
            onChange={() => null}
            className="mr-4  ml-3 rounded border border-gray-300 checked:bg-[#FB6A07] checked:hover:bg-[#FB6A07]"
          />
          <label>
            <span className="flex flex-col text-sm">
              <span>{props.label}</span>
              <span className="mt-[2px] text-gray-400">{`DOB: ${props.data.dob}`}</span>
            </span>
          </label>
        </div>
      </components.Option>
    </div>
  );
};

export const CustomMenuWithSearch = ({
  selectProps,
  ...props
}: any): JSX.Element => {
  const { onInputChange, inputValue, menuLabel } = selectProps;
  return (
    <div data-testid="custom-menu">
      {menuLabel && <p className="px-4 pt-4 pb-3 text-xs">{menuLabel}</p>}
      <div
        className="px-3 py-2"
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <div className="flex items-center border border-gray-300 rounded-md bg-white h-[38px] px-2">
          <MagnifyingGlassIcon className="h-4 w-4 text-gray-400 flex-shrink-0" />
          <input
            autoCorrect="off"
            autoComplete="off"
            spellCheck="false"
            type="text"
            name="custom-search-input"
            id="custom-search-input"
            value={inputValue || ""}
            onChange={(e) =>
              onInputChange(e.currentTarget.value, {
                action: "input-change",
              })
            }
            onMouseDown={(e) => {
              e.stopPropagation();
            }}
            onTouchEnd={(e) => {
              e.stopPropagation();
            }}
            placeholder="Search"
            className="border-none bg-transparent flex-1 ml-2 placeholder:text-gray-400 text-sm text-gray-900 focus:outline-none focus:ring-0"
          />
        </div>
      </div>
      <components.MenuList {...props} selectProps={selectProps} />
    </div>
  );
};
